import type { BreakRequestsTheme } from '@runhuman/break-requests-ui';

/**
 * Adapter that maps the iframe's design tokens (`packages/discord-activity/
 * src/styles/tokens.css`) onto the `BreakRequestsTheme` slice consumed by the
 * shared `<CounterOfferModal>` and `<BreakProposalChain>` widgets.
 *
 * The literal hex/rgba values are mirrored from `tokens.css` on purpose:
 * tokens.css itself documents that values are "duplicated from the web app on
 * purpose" until a third surface justifies a `@runhuman/design-tokens`
 * package (#3751). Doing the same here keeps a single, audit-friendly diff
 * whenever the brand updates a colour — both files change together in the
 * same PR.
 *
 * `primaryButtonText` is the page background hex (#121212) — the brand
 * primary is a light green chip, so primary-CTA labels need dark text for
 * contrast (matches the web adapter's choice of `theme.colors.primaryText`).
 */
export const discordActivityBreakRequestsTheme: BreakRequestsTheme = {
  colors: {
    bgPrimary: '#121212',
    bgSecondary: '#1c1c1c',
    bgTertiary: '#202020',
    border: 'rgba(255, 255, 255, 0.1)',
    textPrimary: '#f0f0f0',
    textSecondary: '#b3b3b3',
    textMuted: '#737373',
    error: '#f15e6c',
    primary: '#BDE039',
    primaryButtonText: '#121212',
  },
  spacing: {
    xs: 8,
    sm: 12,
    md: 16,
  },
  fontSize: {
    xs: 11,
    sm: 13,
    md: 16,
  },
  radius: {
    xs: 4,
    sm: 6,
  },
  transitions: {
    fast: '0.15s ease',
  },
};
